<template>
  <div class="page-view">
    <div class="scroll-view-wrapper new_exercise">
      <Header @backFn="backFn" />
      <div class="new_exercise_container">
        <div class="training_camp-tab-container">
          <!-- 列表 -->
          <div class="training_camp-info" v-show="loaded">
            <div class="training_camp-info__header">
              <div class="progress">
                <van-circle
                  :stroke-width="160"
                  :current-rate="(Number(exerciseInfo.current) / Number(exerciseInfo.total)) * 100"
                  color="#6183F2"
                  layer-color="#EDEDF0"
                  :rate="30"
                  :speed="100"
                  :text="exerciseInfo.current +'/' + exerciseInfo.total"
                />
              </div>
              <div class="title">
                <p class="text-overflow exerciseName">{{exerciseInfo.exerciseName}}</p>
              </div>
            </div>

            <div class="training_camp-info__main">
              <!-- <div class="training_camp-info__remind">
                <div class="wrapper">
                  <template v-if="exerciseInfo.status === 'OPEN' && exerciseInfo.planType !='TODAY'">
                    <p>完成该专题预计需要{{exerciseInfo.totalDayCount}}天</p>
                  </template>
                  <template v-else-if="exerciseInfo.status === 'NOT_STARTED'">
                    <p>当前专题未开始，开营日期：{{exerciseInfo.startedDate}}</p>
                  </template>
                  <template v-else-if="exerciseInfo.status === 'CLOSED'">
                    <p>当前专题已结束，快去复习下所学知识吧</p>
                  </template>
                </div>
              </div> -->
              <!-- 里程碑 -->
              <mile-stone
                :list="exerciseInfo.plans"
                @change="mileStoneChangeAction"
                v-show="exerciseInfo.planType != 'TODAY'"
                :totalDayCount="exerciseInfo.totalDayCount"
                :currentDayCount="exerciseInfo.currentDayCount"
                :currentPlanDate="currentPlanDate"
              />

              <template v-if="currentTasks.length > 0">
                <study-task
                  :id="exerciseInfo.exerciseId"
                  :taskList="currentTasks"
                  :summary="currentSummary"
                  :disabled="exerciseInfo.status === 'NOT_STARTED'"
                  :taskStatus="currentTaskStatus"
                  @task="handleTaskModal"
                  class="noPadding"
                />
              </template>
              <template v-else>
                <no-task />
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-safe-area-inset"></div>
    </div>
    <!-- 里程碑未解锁 -->
    <unlock-modal
      :text="overdueDay"
      :visible="unlockModalVisible"
      @close="showUnlockModal"
      @toTask="handleToTask"
    />
    <!-- 里程碑待解锁 -->
    <wait-lock-modal
      :visible="waitlockModalVisible"
      :time="unlockTime"
      @close="showWaitlockModal"
    />
    <!-- 训练营未开始 -->
    <no-start-modal
      :visible="noStartModalVisible"
      :time="noStartTime"
      @close="showNoStartModal"
    />
  </div>
</template>

<script setup>
import { onMounted, ref, getCurrentInstance } from 'vue'
import { getExerciseDetail } from '@api/exercise'
import { dateFmt } from '@/components/exercise/utils/time'
import NoTask from '@/components/exercise/no-task/index.vue'
import MileStone from '@/components/exercise/milestone/index.vue'
import StudyTask from '@/components/exercise/study-task/index.vue'
import UnlockModal from '@/components/exercise/unlock-modal/index.vue'
import WaitLockModal from '@/components/exercise/wait-lock-modal/index.vue'
import NoStartModal from '@/components/exercise/no-start-modal/index.vue'
import lodashFind from 'lodash/find'
import cloneDeep from 'lodash/cloneDeep'
import Header from '@com/common/Header.vue';
const {
  proxy: { $showLoading, $hideLoading, $router, $toast, $store }
} = getCurrentInstance()
const { currentRoute } = $router

// 页面返回
const backFn = () => {
  $router.replace({
    name: 'learnListExercise',
    query: {
      depId: currentRoute.value.query.depId || ""
    }
  })
}
const exerciseInfo = ref({});
const loaded = ref(false)
let depId;
// 练习专辑ID
const exerciseId = currentRoute.value.params.id;
// 获取练习专辑信息
const getDetail = () => {
  $showLoading()
  getExerciseDetail({
    exerciseId: exerciseId
  }).then(res => {
    $hideLoading();
    if (res.code === 200) {
      loaded.value = true;
      exerciseInfo.value = res.data;
      document.title = res.data.exerciseName;
      depId = res.data.departmentId;
      getTasks()
    } else if (res.code === 520) {
      let query = getQuery()
      // 没有购买，无法作答
      $router.replace({
        name: 'learnListExercise',
        query
      })
    } else {
      $toast(res.message)
    }
  })
}
const getQuery = () => {
  let query = {};
  let dep = depId || currentRoute.value.query.depId;
  let sourceId = currentRoute.value.query.sourceId;
  query.depId = dep;
  if (sourceId) {
    query.sourceId = sourceId;
  }
  return query;
}
// 未开营的时间
const noStartTime = ref('')
// 展开列表
const dateNow = dateFmt(new Date(), 'yyyy/MM/dd')

const currentPlan = ref({})
const currentPlanDate = ref(dateNow)// 当前展示里程碑日期

const currentTasks = ref([]) // 当前展开的里程碑任务
const currentSummary = ref([]) // 当前里程碑任务类型
const currentTaskStatus = ref('') // 当前里程碑任务状态
const overdueDay = ref('') // 逾期未完成任务日期
const unlockTime = ref('') // 未解锁里程碑开始时间

$store.commit('SET_CHOOSEDATE', dateNow)
// 获取当前里程碑任务
const getTasks = () => {
  // 当前日历选中日期中的里程碑数据
  let data = lodashFind(exerciseInfo.value.plans, { exercisedDate: $store.state.chooseDate })
  if (data) {
    currentPlan.value = data
    currentPlanDate.value = $store.state.chooseDate
  } else {
    // 里程碑数据
    let dataPlan = lodashFind(exerciseInfo.value.plans, { exercisedDate: dateNow }) || exerciseInfo.value.plans[0]
    currentPlan.value = cloneDeep(dataPlan)
    currentPlanDate.value = dataPlan.exercisedDate
  }
  // 逾期里程碑
  const overduePlan = lodashFind(exerciseInfo.value.plans, { status: "OVERDUE" })
  overdueDay.value = overduePlan && overduePlan.exercisedDate
  // 未解锁待解锁时间
  if (currentPlan.value.status === 'LOCKED') {
    unlockTime.value = currentPlan.value.exercisedDate
  }
  currentTasks.value = currentPlan.value.tasks
  currentTaskStatus.value = currentPlan.value.status
  currentSummary.value = currentPlan.value.summaries
}

// 选择里程碑
const mileStoneChangeAction = (item) => {
  currentTasks.value = cloneDeep(item.tasks)
  currentPlanDate.value = item.exercisedDate
  getTasks()
}
// 展示逾期里程碑任务
const handleToTask = () => {
  showUnlockModal(false)
  $store.commit('SET_CHOOSEDATE', overdueDay.value)
  mileStoneChangeAction({ exercisedDate: overdueDay.value })
}
// 任务状态提示
const handleTaskModal = val => {
  if (val === 0) {
    showNoStartModal(true)
  } else if (val === 1) {
    showWaitlockModal(true)
  } else if (val === 2) {
    showUnlockModal(true)
  }
}

// 未解锁弹窗
const unlockModalVisible = ref(false)
const showUnlockModal = val => {
  unlockModalVisible.value = val
}

// 待解锁弹窗
const waitlockModalVisible = ref(false)
const showWaitlockModal = val => {
  waitlockModalVisible.value = val
}

// 未开始弹窗
const noStartModalVisible = ref(false)
const showNoStartModal = val => {
  noStartModalVisible.value = val
}

onMounted(() => {
  getDetail();
})
</script>

<style lang="scss" scoped>
@import "~@/components/exercise/style/default.scss";
@import "./index.scss";
</style>
